import ST1 from './site-templates/st1'
import ST2 from './site-templates/st2'
import ST3 from './site-templates/st3'

const siteTemplates = {
    ST1,
    ST2,
    ST3
}

export const DefaultGlobalStyles = {
    typography: {
        '*':{
            fontFamily: 'Barlow'
        },
        'learnworlds-main-text':{
            fontFamily: 'Barlow'
        },
        'learnworlds-heading':{
            fontFamily: 'Barlow'
        },
        'learnworlds-subheading':{
            fontFamily: 'Barlow'
        },
        'learnworlds-heading3':{
            fontFamily: 'Barlow'
        },
        'learnworlds-heading4':{
            fontFamily: 'Barlow'
        },
        'learnworlds-button':{
            fontFamily: 'Barlow'
        },
        'learnworlds-input':{
            fontFamily: 'Barlow'
        },
        'learnworlds-heading-large':{
            fontSize: 60,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.2,
            textTransform: 'uppercase',
        },
        'learnworlds-heading-normal': {
            fontSize: 50,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.2,
            textTransform: 'uppercase'
        },
        'learnworlds-heading-small': {
            fontSize: 40,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.2,
            textTransform: 'uppercase'
        },
        'learnworlds-subheading-large': {
            fontSize: 35,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.2,
            textTransform: 'uppercase'
        },
        'learnworlds-subheading-normal': {
            fontSize: 29,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.2,
            textTransform: 'uppercase'
        },
        'learnworlds-subheading-small': {
            fontSize: 25,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.2,
            textTransform: 'uppercase'
        },
        'learnworlds-heading3-large': {
            fontSize: 24,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-heading3-normal': {
            fontSize: 21,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-heading3-small': {
            fontSize: 18,
            fontWeight: 'bold',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-heading4-large': {
            fontSize: 21,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-heading4-normal': {
            fontSize: 18,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-heading4-small': {
            fontSize: 14,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.4,
            textTransform: 'uppercase'
        },
        'learnworlds-main-text-huge': {
            fontSize: 90,
            fontWeight: '300',
            letterSpacing: 0,
            lineHeight: 1,
            textTransform: 'none',
        },
        'learnworlds-main-text-very-large': {
            fontSize: 50,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-large': {
            fontSize: 22,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-normal': {
            fontSize: 18,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-small': {
            fontSize: 16,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-very-small': {
            fontSize: 14,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-main-text-tiny': {
            fontSize: 12,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-quote-text': {
            fontFamily: 'Barlow',
            fontSize: 32,
            fontWeight: 'normal',
            letterSpacing: 0,
            lineHeight: 1.55,
            textTransform: 'none',
        },
        'learnworlds-overline-text': {
            fontFamily: 'Barlow',
            fontSize: 14,
            fontWeight: 'bold',
            letterSpacing: 0.1,
            lineHeight: 1.55,
            textTransform: 'uppercase'
        }
    },
    input: {
        'learnworlds-button-large': {
            fontSize: 20,
            fontWeight: 'bold',
            letterSpacing: 0,
            paddingTop: 20,
            paddingRight: 32,
            paddingBottom: 20,
            paddingLeft: 32,
            textTransform: 'uppercase'
        },
        'learnworlds-button-normal': {
            fontSize: 18,
            fontWeight: 'bold',
            letterSpacing: 0,
            paddingTop: 15,
            paddingRight: 27,
            paddingBottom: 15,
            paddingLeft: 27,
            textTransform: 'uppercase'
        },
        'learnworlds-button-small': {
            fontSize: 14,
            fontWeight: 'bold',
            letterSpacing: 0,
            paddingTop: 11,
            paddingRight: 22,
            paddingBottom: 11,
            paddingLeft: 22,
            textTransform: 'uppercase'
        },
        'learnworlds-input-large': {
            fontSize: 20,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 20,
            paddingRight: 20,
            paddingBottom: 20,
            paddingLeft: 20
        },
        'learnworlds-input-normal': {
            fontSize: 18,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 15,
            paddingRight: 15,
            paddingBottom: 15,
            paddingLeft: 15
        },
        'learnworlds-input-small': {
            fontSize: 14,
            lineHeight: 1,
            fontWeight: 'normal',
            letterSpacing: 0,
            textTransform: 'none',
            paddingTop: 11,
            paddingRight: 11,
            paddingBottom: 11,
            paddingLeft: 11
        }
    },
    colors: {
        'lw-brand-bg': {
            color: '#3238ca',
            textType: 'light',
            lessVars: {
                'brand-color': '#3238ca',
                'text-over-brandbg-color' : '@light-text-color'
            }
        },
        'lw-dark-bg': {
            color: '#251d7f',
            textType: 'light',
            lessVars: {
                'dark-bg-color': '#251d7f',
                'text-over-darkbg-color' : '@light-text-color'
            }
        },
        'lw-light-bg': {
            color: '#f8f8fd',
            textType: 'dark',
            lessVars: {
                'light-bg-color': '#f8f8fd',
                'text-over-lightbg-color' : '@dark-text-color'
            }
        },
        'lw-brand-accent1-bg': {
            color: '#fec674',
            textType: 'light',
            lessVars: {
                'brand-accent1-color': '#fec674',
                'text-over-brandaccent1bg-color' : '@light-text-color'
            }
        },
        'lw-brand-accent2-bg': {
            color: '#59d8e0',
            textType: 'light',
            lessVars: {
                'brand-accent2-color': '#59d8e0',
                'text-over-brandaccent2bg-color' : '@light-text-color'
            }
        },
        'lw-light-text': {
            color: '#ffffff',
            lessVars: {
                'lw-light-text': '#ffffff',
            }
        },
        'lw-dark-text': {
            color: '#000000',
            lessVars: {
                'lw-dark-text': '#000000',
            }
        },
        'lw-body-bg': {
            color: '#ffffff',
            textType: 'dark',
            lessVars: {
                'body-bg': '#ffffff',
            }
        },
        'lw-link-text': {
            color: 'red',            
            lessVars: {
                'link-text-color': 'red',
            }
        }

    },
    fonts: [
        'Barlow',
        'Barlow'
    ]
}

export const SiteTemplateFactory = {
    get: name => {
        if (!name) {
            return DefaultGlobalStyles
        }

        let siteTemplate = name.toUpperCase();
        return siteTemplates[siteTemplate]
    }
}